<template>
  <div class="container mt-md-5 col-md-6 p-4">
    <div class="row">
      <h2 class="text-uppercase">{{ $t('settings.title') }}</h2>
      <form @submit.prevent="saveSettings">
        <div class="col-12">
          <div class="row g-0 column-gap-1 align-items-center">
            <!-- Dynamische Generierung von Checkboxen -->
            <template
                v-for="(field, key) in config">
              <div
                  class="form-check form-switch"
                  v-if="field.type === 'checkbox'"
                  :key="key"
              >
                <input
                    class="form-check-input"
                    type="checkbox"
                    :id="key"
                    v-model="settings[key]"
                />
                <label class="form-check-label" :for="key">{{ $t('settings.' + key) }}</label>
              </div>

              <!-- Dynamische Generierung der Eingabefelder -->
              <div
                  class="mb-3"
                  v-if="field.type === 'number'"
                  :key="key"
              >
                <label :for="key" class="form-label">{{ $t('settings.' + key) }}</label>
                <input
                    class="form-control"
                    type="number"
                    :id="key"
                    v-model.number="settings[key]"
                    :max="field.max"
                />
              </div>

              <!-- Dynamische Generierung von Select-Elementen -->
              <div
                  class="mb-3"
                  v-if="field.type === 'select'"
                  :key="key"
              >
                <label :for="key" class="form-label">{{ $t('settings.' + key) }}</label>
                <select
                    class="form-select"
                    :id="key"
                    v-model="settings[key]"
                >
                  <option
                      v-for="option in field.options"
                      :value="option.value"
                      :key="option.value"
                  >
                    {{ option.label }}
                  </option>
                </select>
              </div>
            </template>
            <div class="row g-0 column-gap-1 align-items-center mt-2">
              <button type="submit" class="col btn btn-bb5-yellow m-0 p-2">{{ $t('save') }}</button>
              <button @click="back" class="col btn btn-bb5-black m-0 p-2">{{ $t('back') }}</button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: "Settings",
  data() {
    return {
      // Konfigurationsobjekt zur Definition der Einstellungen
      config: {
        useApi: { type: "checkbox", label: "Use API" },
        savePlayerLocal: { type: "checkbox", label: "Save player locally" },
        showBallPos: { type: "checkbox", label: "Show previous ball position" },
        showHeatMap: { type: "checkbox", label: "Show heat map" },
        useNames: { type: "checkbox", label: "Use player names" },
        changeLineupInGame: { type: "checkbox", label: "Change lineup in game" },
        maxGames: { type: "number", label: "max. games saved", max: 50 },
        languageSelection: {
          type: "select",
          label: "Language Selection",
          options: [
            { value: "en", label: "English" },
            { value: "de", label: "German" },
          ],
        },
      },
      // Zustand der gespeicherten Einstellungen
      settings: {
        useApi: false,
        savePlayerLocal: true,
        showBallPos: false,
        showHeatMap: false,
        useNames: false,
        changeLineupInGame: false,
        maxGames: 10,
        languageSelection: "en", // Default-Wert für die Sprache
      },
    };
  },
  mounted() {
    this.loadSettings(); // Einstellungen beim Mount laden
  },
  methods: {
    saveSettings() {
      // Alle Einstellungen in localStorage speichern
      for (const key in this.settings) {
        localStorage.setItem(key, this.settings[key]);
      }
      // Falls languageSelection geändert wurde
      if (this.settings.languageSelection) {
        this.changeLanguage(this.settings.languageSelection);
      }
    },
    loadSettings() {
      // Alle Einstellungen aus localStorage laden
      for (const key in this.settings) {
        if (localStorage.getItem(key) !== null) {
          const value = localStorage.getItem(key);
          // Datentyp basierend auf dem Typ in config setzen
          this.settings[key] =
              this.config[key].type === "checkbox" ? value === "true" : value;
          if (this.config[key].type === "number") {
            this.settings[key] = Number(value);
          }
        }
      }
    },
    changeLanguage(lang) {
      if (this.$i18n) {
        this.$i18n.locale = lang;
      } else {
        console.error("i18n global instance is not available");
      }

    },
    back() {
      this.$router.push("/");
    },
  },
};
</script>

<style scoped>
</style>